namespace GeniuzPOS.Inventory {
    export interface IcStockSkuForm {
        SkuCode: Serenity.StringEditor;
        QtyOnhand: Serenity.DecimalEditor;
        StockCostValue: Serenity.DecimalEditor;
    }

    export class IcStockSkuForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockSku';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockSkuForm.init)  {
                IcStockSkuForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(IcStockSkuForm, [
                    'SkuCode', w0,
                    'QtyOnhand', w1,
                    'StockCostValue', w1
                ]);
            }
        }
    }
}
